interface SearchBadgeProps {
  value: string;
  onClear: () => void;
}

export const SearchBadge = ({ value, onClear }: SearchBadgeProps) => {
  return (
    <div className="badge badge-soft badge-info badge-md inline-flex items-center gap-1 pr-1">
      {value}
      <button
        type="button"
        className="inline-flex size-4 items-center justify-center rounded-sm transition-colors hover:bg-info/20"
        onClick={onClear}
        aria-label={`Verwijder filter ${value}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          className="text-error size-3"
          aria-hidden="true"
        >
          <path d="M4 4l8 8" />
          <path d="M12 4 4 12" />
        </svg>
      </button>
    </div>
  );
};